module.exports = __webpack_public_path__ + "create/static/media/bannerA2_Fundo.bf3b704e.png";


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/CreateExperience/Institucional/bannerA2_Fundo.png
// module id = 473
// module chunks = 37